var CommentContextType = /*#__PURE__*/ function(CommentContextType) {
    CommentContextType["Document"] = "DOCUMENT";
    return CommentContextType;
}(CommentContextType || {});
var CommentContextSubType = /*#__PURE__*/ function(CommentContextSubType) {
    CommentContextSubType["Discussion"] = "DISCUSSION";
    return CommentContextSubType;
}(CommentContextSubType || {});
export var DocumentSourceType = /*#__PURE__*/ function(DocumentSourceType) {
    DocumentSourceType["SpaceTab"] = "SPACE_TAB";
    DocumentSourceType["StatusUpdate"] = "STATUS_UPDATE";
    return DocumentSourceType;
}({});
